import { render, staticRenderFns } from "./sponser.vue?vue&type=template&id=a6d8453e&scoped=true&"
import script from "./sponser.vue?vue&type=script&lang=js&"
export * from "./sponser.vue?vue&type=script&lang=js&"
import style0 from "./sponser.vue?vue&type=style&index=0&id=a6d8453e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d8453e",
  null
  
)

export default component.exports